/**
 * Holds the active mic stream for internal /record capture across React StrictMode
 * remounts in development (refs reset while WS handshake is in flight).
 */
let activeCaptureStream: MediaStream | null = null

export function registerInternalMeetingCaptureStream(stream: MediaStream | null): void {
  activeCaptureStream = stream
}

export function getInternalMeetingCaptureStream(): MediaStream | null {
  return activeCaptureStream
}
